import * as React from 'react';

import {Card} from "@mui/material";
import {styled} from "@mui/material/styles";

const StyledCard = styled(Card)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    flex:1,
    border: '1px solid #eeecec',
    '& .MuiCardHeader-root': {
        position:'relative',
        '& .MuiLinearProgress-root': {
            position: 'absolute',
            bottom: 0,
            left: 0,
            zIndex: 1000,
            width: '100%',
        },
        '& .MuiCardHeader-title': {
            fontSize: '1.2rem',
            fontWeight: 300,
            // Using theme.breakpoints for responsive styles
            [theme.breakpoints.down('sm')]: {
                //display: 'none', // Hide title for small screens
            },
            [theme.breakpoints.up('sm')]: {
                display: 'block', // Show title for medium screens and above
            },
        },
        '& .MuiCardHeader-avatar': {
            marginRight: 0,
        },
        '& .MuiCardHeader-action': {
            margin:0,
            '& .MuiButton-root': {
            }
        }
    },
    '& .MuiCardContent-root': {
        flex:1,
        overflowY: 'auto',
        '& .MuiTable-root': {
            '& .MuiTableHead-root': {
                '& .MuiTableRow-root': {
                    '& .MuiTableCell-root': {
                        fontSize: '0.8rem',
                        fontWeight: 400,
                        color: theme.palette.text.primary,
                    }
                }
            },
            '& .MuiTableBody-root': {
                '& .MuiTableRow-root': {
                    '& .MuiTableCell-root': {
                        fontSize: '0.85rem',
                        fontWeight: 400,
                        color: theme.palette.text.secondary,
                    }
                }
            }
        }
    },
    '& .MuiCardActions-root': {
        'justifyContent': 'space-between',
        'padding': theme.spacing(3),
    },
}));


export const DialogCard = ({children, props, styles}) => {

    return (
        <StyledCard {...props} {...styles}>
            {children}
        </StyledCard>
    )
}